import { render, staticRenderFns } from "./UiProgressCircular.vue?vue&type=template&id=7994f1fe"
import script from "./UiProgressCircular.vue?vue&type=script&lang=js"
export * from "./UiProgressCircular.vue?vue&type=script&lang=js"
import style0 from "./UiProgressCircular.vue?vue&type=style&index=0&id=7994f1fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports